// extracted by mini-css-extract-plugin
export var focusCard = "focus-card-module--focusCard--gMCsB";